<script>
const AFTER_ONBOARDING_VIDEOS = {
    ...addAfterOnboardVideo(
        ["cookie", "Easycookie"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "LS9WF6sZmLM", en: "WvBa1dxdk70" }
    ),
    ...addAfterOnboardVideo(
        ["coffee", "Easycoffee"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "3B2I3y7Xiac", en: "Fg44yczKppQ" }
    ),
    ...addAfterOnboardVideo(
        ["faq", "EasyFAQ"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "qmo3obR3PKU", en: "FqD-8ez2I-k" }
    ),
    ...addAfterOnboardVideo(
        ["legal", "Easylegal"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "X6eEHGwmk2I", en: "RVVAVZIk8Ro" }
    ),
    ...addAfterOnboardVideo(
        ["love", "Easylove"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "ynOQj9Bntvg", en: "HIAb-pmIIO4" }
    ),
    ...addAfterOnboardVideo(
        ["page", "Easypage"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "", en: "" } // todo: change links from "cart" to "page" videos when on wistia ready!
    ),
    ...addAfterOnboardVideo(
        ["player", "Easyplayer"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "a2j7Rn7uaBM", en: "09zmPfbIhfk" }
    ),
    ...addAfterOnboardVideo(
        ["pricing", "Easyoffer"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "ihOqYjETW9E", en: "JzxdHZvnJ2k" },
        "offer"
    ),
    ...addAfterOnboardVideo(
        ["ticker", "Easyticker"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "", en: "" },
        "easyticker"
    ),
    ...addAfterOnboardVideo(
        ["timer", "Easytimer"],
        "shared.help.video_title",
        "shared.help.video_subtitle",
        { pl: "", en: "" }
    ),
};

function addAfterOnboardVideo(
    [tool, businessToolName],
    title,
    subtitle,
    videoIds = { pl: "", en: "" },
    businessLink
) {
    return {
        [tool]: {
            title,
            subtitle,
            videoIds,
            businessLink: businessLink || tool,
            businessToolName,
        },
    };
}
</script>
<script setup>
import { NotificationWithVideo } from "@easy/ui/notifications";
import { computed } from "vue";
import { useState } from "@/store/vuex-composition-mappers";
import { useI18n } from "vue-i18n";
import { t } from "@/i18n";
import { useLocalStorage } from "@vueuse/core";
import { prefixedKey, STORAGE_KEY } from "@/shared/connection/local-storage.service";

const { locale } = useI18n();
const { activeApp } = useState(["activeApp"]);
const localStorageClosedHelpVideos = useLocalStorage(prefixedKey(STORAGE_KEY.closeHelpVideos), []);
const video = computed(() => {
    const { videoIds, title, subtitle, businessToolName } =
        AFTER_ONBOARDING_VIDEOS[activeApp.value] || {};
    const currentLang = locale.value || "en";
    const id = videoIds?.[currentLang];
    return {
        id,
        title: t(title, { tool: businessToolName }),
        subtitle: t(subtitle, { tool: businessToolName }),
        videoLink: `https://youtu.be/${id}`,
        imageLink: `https://img.youtube.com/vi/${id}/maxresdefault.jpg`,
        show: !localStorageClosedHelpVideos.value.includes(activeApp.value),
        closeVideo: () => localStorageClosedHelpVideos.value.push(activeApp.value),
    };
});
</script>

<template>
    <div
        v-if="video.id && video.show"
        class="absolute right-2 top-20 space-y-6 items-start hidden lg:block w-[40%] z-50"
    >
        <NotificationWithVideo
            :title="video.title"
            :subtitle="video.subtitle"
            :ctaLabel="$t('shared.creator.help_video.watch')"
            :video-src="video.videoLink"
            :thumbnail="video.imageLink"
            dontApplyAspectVideo
            ctaPlaysVideo
            @close="video.closeVideo()"
        />
    </div>
</template>
